import type { SanityPageBuilderBenefitListItem, SanityPageBuilderBenefitsListSection, SanityPageBuilderSection } from "@ouster/shared";
import { BenefitsListBlockView } from "~/features/blocks/inventory/benefits-list";
import { BenefitListItemView } from "~/features/blocks/inventory/benefits-list/benefit-list-item";
import { SanityRichText } from "~/features/sanity/rich-text";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderBenefitsListSection;
  };
};
export function SanityBenefitsListSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const items = sectionContent.items ?? [];
  return <BenefitsListBlockView<SanityPageBuilderBenefitListItem> anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} getItemKey={(item, index) => item._key || index} hasTopDivider={sectionSettings?.hasTopDivider ?? true} items={items} mode={sectionSettings?.mode || "light"} renderItem={item => <BenefitListItemView text={item.text?.length ? <SanityRichText value={item.text} /> : undefined} title={item.title} />} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} theme={sectionSettings?.theme || "white"} />;
}